/** Email-first homepage, grounded in goodsender-v2-docs/01 and /03.
 * Keep AI publishing's full story in LANDING, at /ai-blogging-platform.
 */
export const EMAIL_LANDING = {
  hero: {
    eyebrow: "From the team behind SendGrid and Laneful",
    headline: "We’re email people.",
    headlineAccent: "Now we publish, too.",
    subhead: "Your company blog and newsletter, built on the same engine that powers our email API. Permission enforced. Engagement monitored. Reputation earned.",
    transactional: "Send transactional email from the same account. One engine for everything your business sends.",
    proofLine: "Email is our foundation. Your blog is built on it.",
  },
  engine: {
    eyebrow: "The sending engine",
    title: "The inbox is the hard part",
    body: "A published post needs a home. An email needs to reach the people who asked for it. We built the sending engine first, then added a place to publish.",
    credit: "Every send runs on Laneful, from the team behind SendGrid. Email expertise is the foundation of the platform.",
  },
  productsTitle: "Everything your business sends",
  apiCta: "Explore the email API",
  products: [
    { name: "Transactional email", body: "Send receipts, account notifications, and other transactional messages through the email API." },
    { name: "Permission-based newsletters", body: "Reach confirmed subscribers with a subject line, a summary, and a link to your published post." },
    { name: "A blog on your own domain", body: "Publish on your own domain or a GoodSender address, with search-friendly pages, RSS, and your brand." },
  ],
  workflow: {
    eyebrow: "Publish. Then send.",
    title: "Your blog and newsletter, together",
    items: [
      { name: "Write", body: "Start in the editor, or bring your AI assistant. Give every post a permanent home on your blog." },
      { name: "Build your audience", body: "Readers subscribe and confirm by email. Your newsletter reaches people who asked to hear from you." },
      { name: "Review and send", body: "Review the subject and summary in the dashboard. Select the newsletter to send a link to your post when you publish." },
    ],
  },
  blog: {
    eyebrow: "The blog platform",
    title: "A home for your ideas. Built on our email engine.",
    body: "Your domain, your design, your audience. Write in the editor or publish from Claude or ChatGPT through MCP. Review your post and choose where it goes, from your blog and newsletter to your social channels.",
    cta: "Explore the blog platform",
  },
  ai: {
    eyebrow: "AI & MCP server",
    title: "Your email and blog. Connected to your AI.",
    body: "Connect Claude, ChatGPT, or another MCP-compatible assistant to GoodSender’s official MCP server. Work with your email tools and your blog from the assistant you already use.",
    features: [
      { name: "Email workflows", body: "Work with templates, senders, recipients, and groups. Marketing sends still require recipient consent." },
      { name: "Blog publishing", body: "Prepare drafts, preview posts, and publish to your blog. Choose the destinations for each post." },
      { name: "MCP, CLI, and Skills", body: "Use MCP to connect your assistant, the CLI for terminal workflows, and Skills for an editorial process." },
    ],
    cta: "Explore AI tools",
    setupCta: "Connect the MCP server",
  },
  finalCta: {
    headline: "Publish something worth sending.",
    body: "Your blog, newsletter, and transactional email. Together on an engine built by email people.",
    closing: "Free to start. Pay for sends, not subscribers.",
  },
} as const;
